import { Table } from "@/features/Table";
import {
  type StrategyPermission,
  strategy_permission_columns,
} from "./columns";
import {
  type FilterStrategyPermissionSchema,
  FilterStrategyPermission,
} from "./filter";

const client = "legacy-quantilia";
const table_name = "strategy_permissions";

export const StrategyPermissionTable = () => {
  return (
    <Table<StrategyPermission, FilterStrategyPermissionSchema>
      label="Strategy Permissions"
      client={client}
      table_name={table_name}
      columns={strategy_permission_columns}
      filter={<FilterStrategyPermission />}
      disable_translations_request={true}
    />
  );
};
